import { useEffect, useState, useLayoutEffect } from "react";
import {getParamsEmpresa} from "../../../services/params";
import PropTypes from 'prop-types';
import MenuItem from "./menuitem";

function Menu({expand, setSede, setEmpresa}) {
    const [arbol, setArbol] = useState([]); // Esto asegura que arbol es un array
    const addParametros = async () => {
        const response = await getParamsEmpresa();
          if (response.status === 200) {
            setSede(response.data.data[0]?.NombreArea);
            setEmpresa(response.data.Empresa[0]?.NombreTerc);
            document.title = `Waitless - ${response.data.Empresa[0]?.NombreTerc}`;
            const menu = construirArbol(response.data.MenuTipo1);
            setArbol(menu);
           } 
          else {
            //const Mensaje = response.message;
           // const opc = { type: "Danger", message: Mensaje, active: true };
         //   setOpciones(opc);
         //   setShowToast(true);
          }
    }

    function construirArbol(items) {
      const map = {};
      const raiz = [];
    
      items.forEach(item => (map[item.MenuId] = { ...item, hijos: [] }));
    
      items.forEach(item => {
        if (item.PadreId) {
          map[item.PadreId].hijos.push(map[item.MenuId]);
        } else {
          raiz.push(map[item.MenuId]);
        }
      });
    
      return raiz;
    }
    
    useEffect(() => {
        addParametros();
      }, []);

      useLayoutEffect(() => {
      //const sidebar = document.getElementById('menuprincipal');                  
      //const labels = sidebar.querySelectorAll('span');
      //   labels.forEach(label => label.classList.toggle('opacity-0'));
      
      }, [expand]);

 //   useLayoutEffect(()=>{AgregarHijos(MenuTipo2N)});
    return (
      <ul className="flex flex-col w-full pl-2 pr-2 md:pl-4 mt-10 space-y-3 list-none" id="menuprincipal">
          {arbol.map(item => (
            <MenuItem key={item.MenuId} item={item} expand={expand} /> 
          )
                    )
          }
    </ul>
   )
}

Menu.propTypes = {
  expand: PropTypes.bool.isRequired,
  setSede: PropTypes.func.isRequired,
  setEmpresa: PropTypes.func.isRequired,
};


export default Menu;
